import CertificateCard from "./CertificateCard";
import Checkbox from "./Checkbox";
import CircleProgress from "./CircleProgreso";
import FooterLogin from "./FooterLogin";
import HeaderDashboard from "./HeaderDashboard";
import HeaderLogin from "./HeaderLogin";
import Input from "./Input";

const useComponents = () => {
    return {
        Input,
        HeaderLogin,
        FooterLogin,
        HeaderDashboard,
        CircleProgress,
        CertificateCard,
        Checkbox
    };
}

export default useComponents;